import React                     from 'react';
import PropTypes                 from 'prop-types';
import DesktopPrevDayItem        from './DailybonusYestardayItem';
import DesktopTodayItem          from './DailybonusTodayItem';
import DailybonusPrevDayItemItem from '../VXMobile/Dailybonus/Blocks/DailybonusPrevDayItem';
import MobileTodayItem           from '../VXMobile/Dailybonus/Blocks/DailybonusTodayItem';
import DailybonusTommorowItem    from './DailybonusTommorowItem';
import {EventConfigPropTypes}    from './EventConfigPropTypes';
import withDailybonus            from '../HigherOrderComponents/Dailybonus/withDailybonus';
import EnumAnalyticsEvents       from '../../utils/EnumAnalyticsEvents';
import Flux                      from '../../flux/Flux';
import withSuspense from '../HigherOrderComponents/Utility/withSuspense';

const Slick = React.lazy(() => import('react-slick'));

const SLIDER_SETTINGS = {
	dots:           true,
	infinite:       false,
	speed:          500,
	slidesToShow:   1,
	slidesToScroll: 1,
	centerMode:     true,
	arrows:         false,
	initialSlide:   1,
	centerPadding:  '0px',
	variableWidth:  true,
	useTransform:   false,
};


class Dailybonus extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isMobile: this.props.isMobile
		};

		this.onWindowChange = this.onWindowChange.bind(this);
		this._isMounted     = false;
	}

	componentDidMount() {
		this._isMounted = true;
		Flux.Browser.addWindowResizeListener(this.onWindowChange);
	}

	/**
	 * Notify GA on render complete
	 */
	componentDidUpdate() {
		window.dataLayer && window.dataLayer.push({'event': EnumAnalyticsEvents.DL_OPTIMIZE_ACTIVATE});
	}

	componentWillUnmount() {
		this._isMounted = false;
		Flux.Browser.removeWindowResizeListener(this.onWindowChange);
	}

	onWindowChange() {
		const isMobile = Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.md;
		if(this._isMounted) {
			this.setState({isMobile});
		}
	}

	mobileView() {
		let showMysterious = false;

		const {dailyBonuses} = this.props;
		const className      = 'dailybonus__mobile-block--slider-item';

		if (this.props.event) {
			showMysterious = this.props.event.showMysteriousTomorrowOffer;
		}

		const slider = dailyBonuses &&
        withSuspense(
			<Slick {...SLIDER_SETTINGS}>
				<div className={className}><DailybonusPrevDayItemItem bonusOffer={dailyBonuses.previous}/></div>
				<div className={className}><MobileTodayItem bonusOffer={dailyBonuses.current}/></div>
				<div className={className}><DailybonusTommorowItem data={dailyBonuses.next} showMysteriousOffer={showMysterious}/></div>
			</Slick>);

		return <div className="dailybonus__mobile-block">{slider}</div>;
	}

	desktopView() {
		const {event, dailyBonuses} = this.props;
		return dailyBonuses && (
			<div className="dailybonus-wrapper">
				<DesktopPrevDayItem data={dailyBonuses.previous} lazyImageLoading={this.props.lazyImageLoading}/>
				<DesktopTodayItem {...dailyBonuses.current} {...event} />
				<DailybonusTommorowItem data={dailyBonuses.next} showMysteriousOffer={event && event.showMysteriousTomorrowOffer}
				                        lazyImageLoading={this.props.lazyImageLoading}/>
			</div>
		);
	}

	render() {
		if (!this.props.show) {
			return null;
		}

		if (this.state.isMobile) {
			return this.mobileView();
		}
		return this.desktopView();
	}
}

Dailybonus.propTypes = {
	show:         PropTypes.bool,
	link:         PropTypes.string,
	dailyBonuses: PropTypes.shape({ // Current offers (3) from VXQL
		current:  PropTypes.shape({}),
		next:     PropTypes.shape({}),
		previous: PropTypes.shape({}),
	}),

	lazyImageLoading: PropTypes.bool,
	event:            EventConfigPropTypes,
	isMobile:         PropTypes.bool,
};

Dailybonus.defaultProps = {
	show:             false,
	link:             '',
	dailyBonuses:     null,
	lazyImageLoading: false,
	event:            null,
	isMobile:         true,
};

export default withDailybonus(Dailybonus);
